import React from "react";

import Overlay from "shared/components/overlay/Overlay";

// Styles
import styles from './SlidingPanel.module.scss';

const SlidingPanel = ({
        className= '',
        children,
        isActive = false
    }) => {

    const panelClasses = `${styles.panel} ${className }`;
    const slidingClasses = isActive ? styles.active : '';

    return (
        <div className={ `${panelClasses } ${slidingClasses}` }>
            { children }
        </div>
    );
};

export default SlidingPanel;
